import { getAPI } from "../../../../api/Networking";
import { OpsAnalyticsData } from "../../../../models/Dashboard/OpsDashboard/OpsAnalytics";
import {
  AnalyticsGraphResponse,
  LabelValue,
} from "../../../../models/Dashboard/Analytics";
import dayjs from "dayjs";
import { UrgentSourcingAnalyticsAPIFilters } from "../../../../models/Dashboard/UrgentSourcingDashboard/UrgentSourcingAnalyticsFilters";

export default class UrgentSourcingAnalyticsDashboardAPI {
  getTatsData = async (
    url: string,
    filters: UrgentSourcingAnalyticsAPIFilters
  ): Promise<LabelValue[] | AnalyticsGraphResponse[] | OpsAnalyticsData> => {
    try {
      const start_date = dayjs(filters.start_date, "YYYY-MM-DD")
        .utc()
        .format("YYYY-MM-DD HH:mm:ss");

      const end_date = dayjs(filters.end_date, "YYYY-MM-DD")
        .add(1, "day")
        .utc()
        .format("YYYY-MM-DD HH:mm:ss");

      const queryParams = new URLSearchParams();

      if (start_date) queryParams.append("start_date", start_date);

      if (end_date) queryParams.append("end_date", end_date);

      if (filters.raised_by && filters.raised_by.length > 0) {
        queryParams.append(
          "raised_by",
          filters.raised_by.map((item) => item.id).join(",")
        );
      }

      if (filters.status_updated_by && filters.status_updated_by.length > 0) {
        queryParams.append(
          "status_updated_by",
          filters.status_updated_by.map((item) => item.id).join(",")
        );
      }

      const response = await getAPI(
        `/v5/ops-analytics/urgent-sourcing${url}?${queryParams.toString()}`
      );
      return response.result;
    } catch (error) {
      throw error;
    }
  };
}
